<template>
  <DashboardPanelTemplate
    :panel-size="panelSize"
    :panel-focus="panelFocus"
    :loading="isLoading"
    :error="error"
    :error-message="$t('ErrorMessage')"
  >
    <div class="order-status-header">
      <h4 v-t="'Title'" />
      <div class="float-right">
        <sb-dropdown
          v-model="selectedOption"
          class="filter"
        >
          <sb-selected-option slot="selection" slot-scope="{ selected }">
            {{ $t(selected) }}
          </sb-selected-option>
          <sb-options>
            <sb-option value="AllOrders">
              {{ $t('AllOrders') }}
            </sb-option>
            <sb-option value="B2B">
              {{ $t('B2B') }}
            </sb-option>
            <sb-option value="B2C">
              {{ $t('B2C') }}
            </sb-option>
          </sb-options>
        </sb-dropdown>
      </div>
    </div>
    <div class="order-status-container">
      <div v-for="orderCount in orderCounts" :key="orderCount.label" class="row order-status-row">
        <div class="col order-status-name">
          <p>{{ $t(orderCount.label) }} </p>
        </div>
        <div class="col order-status-count">
          <p
            class="float-right"
          >
            {{ orderCount.value }}
          </p>
        </div>
      </div>
    </div>
    <div class="panel-footer">
      <button class="btn btn-link" @click="viewOrders()">
        {{ $t('AllOrdersLink') }}
      </button>
    </div>
  </DashboardPanelTemplate>
</template>

<script>
import DashboardPanelTemplate from '@/components/layouts/DashboardPanelTemplate'
import { getTelemetryInstance } from '@/telemetry'

export default {
  name: 'OrderStatusPanel',
  components: {
    DashboardPanelTemplate
  },
  props: {
    panelSize: {
      type: String,
      required: true
    },
    panelFocus: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      requestLoading: true,
      dataStoreLocation: 'dashboard/orderStatus/',
      selectedOption: 'AllOrders'
    }
  },
  computed: {
    isLoading () {
      return this.loading
    },
    error () {
      return this.$shipBobStore.getters[this.dataStoreLocation + 'getLoadingError']
    },
    orderStatusModel () {
      return this.$shipBobStore.getters[this.dataStoreLocation + 'getOrderStatusModel']
    },
    orderCountsByStatus () {
      return this.orderStatusModel[this.selectedOption]
    },
    orderCounts () {
      return [
        /** Checking these values if they are an array is an attempted fix for an intermittent issue described here.
         * I was unable to recreate the issue:
         * https://shipbob.atlassian.net/browse/IPSV2-19610
         * https://shipbob.visualstudio.com/ShipBob/_workitems/edit/280667
         */
        { label: this.$t('Processing'), value: Array.isArray(this.orderCountsByStatus.Processing) ? this.orderCountsByStatus.Processing[0] : this.orderCountsByStatus.Processing },
        { label: this.$t('OnHold'), value: Array.isArray(this.orderCountsByStatus.OnHold) ? this.orderCountsByStatus.OnHold[0] : this.orderCountsByStatus.OnHold },
        { label: this.$t('Exception'), value: Array.isArray(this.orderCountsByStatus.Exceptions) ? this.orderCountsByStatus.Exceptions[0] : this.orderCountsByStatus.Exceptions },
        { label: this.$t('Complete'), value: Array.isArray(this.orderCountsByStatus.Completed) ? this.orderCountsByStatus.Completed[0] : this.orderCountsByStatus.Completed }
      ]
    }
  },
  watch: {
    selectedOption (newValue, oldValue) {
      getTelemetryInstance()?.trackEvent({
        name: 'MERCHANT_APP_DASHBOARD_ORDER_STATS',
        properties: {
          selected: newValue,
          previous: oldValue
        }
      })
    }
  },
  created () {
    this.$shipBobStore.dispatch(this.dataStoreLocation + 'getOrderCounts')
  },
  mounted () {
    // Hotfix to get dropdown to populate initially. Will be replaced by new dropdown anyway.
    this.selectedOption = 'B2C'
    setTimeout(() => { this.selectedOption = 'AllOrders' }, 0)
  },
  methods: {
    viewOrders () {
      getTelemetryInstance()?.trackEvent({
        name: 'MERCHANT_APP_DASHBOARD_ORDER_STATS_ALL_ORDERS'
      })
      this.$router.push({ name: 'Orders' })
    }
  },
  i18n: {
    messages: {
      'en-US': {
        Title: 'Your Orders',
        Processing: 'Processing',
        OnHold: 'On Hold',
        Exception: 'Exception',
        Complete: 'Completed',
        AllOrders: 'All Orders',
        B2B: 'B2B',
        B2C: 'B2C',
        AllOrdersLink: 'View All Orders',
        ErrorMessage: 'Hm... we couldn\'t load your orders data. Please refresh your browser and if you have issues, let our support team know.'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/../assets/scss/shipbob-custom/components/dashboard/_panel-order-status.scss';
</style>
